var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.42,456.27c0,3.39-93.52,6.13-208.87,6.13s-208.87-2.75-208.87-6.13,93.52-6.13,208.87-6.13,208.87,2.75,208.87,6.13Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Planet--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M177.49,37.06c19.77-4.42,39.38,8.01,43.8,27.78,4.42,19.77-8.01,39.38-27.78,43.8-19.77,4.42-39.38-8.01-43.8-27.78l-.03-.13c-4.34-19.73,8.09-39.26,27.81-43.67Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.49,37.06c19.77-4.42,39.38,8.01,43.8,27.78,4.42,19.77-8.01,39.38-27.78,43.8-19.77,4.42-39.38-8.01-43.8-27.78l-.03-.13c-4.34-19.73,8.09-39.26,27.81-43.67Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,56.71c-.67,1.07-1.25-.4-3.61,.8-2.31,1.03-4.79,1.62-7.31,1.74l-.53,1.02c-.49,1.07-4.99-.67-4.99-2.41s0,0,3.48-1.02c3.48-1.02,0,0,.31-2.5,.31-2.5-.98-1.38-2.41-3.12-.77-1.02-2.23-1.22-3.25-.45h0c-1.07,.63-.94,1.83-1.96,2.1-1.03,.27-.58,.89-1.03,1.2-.45,.31-1.16,0-1.74,0s-1.34-.49-1.69,0c-.36,.49-.27,.62-.36,.89-.38,.04-.77,.04-1.16,0-.27,0-.58-.36-.58-.58-.03-.15-.03-.3,0-.45,.19-.44,.44-.85,.76-1.2,.31-.38,.83-.52,1.29-.36,.1-.42-.04-.86-.36-1.16h1.43c.36,0,1.38-2.94,1.47-3.39,.01-.38-.17-.73-.49-.94-.4-.22-.89,0-1.38,0s-1.52-1.38-2.45-1.25c-.24,.07-.46,.17-.67,.31l-1.11,.8c-.19,.08-.36,.2-.49,.36-.02,.24-.02,.48,0,.71-.04,.21-.19,.38-.4,.45,.85,0-.31,.85-.49,.89-.89,.31-2.63-.31-3.65-.4-.17,.07-.36,.07-.53,0-.02-.13-.02-.27,0-.4-.27-.62-.49-1.29-.71-1.92-.22-.62-.71-2.9,.4-3.52,1.11-.62,2.36,0,2.72-1.16,.04-.14,.12-.26,.22-.36,.31-.27,.67,.36,.62,.8-.13,.71-.13,1.43,0,2.14,.27,.71,1.2,1.16,1.74,.71-.36-.53,.36-1.16,.98-1.16s1.34,.31,1.92,0c.51-.32,.76-.93,.62-1.52-.13-.58-.39-1.13-.76-1.6-.76,.3-1.62,.19-2.27-.31-.53-.4-1.07-1.11-1.69-.85,.27-.29,.5-.6,.71-.94-.4-.2-.82-.38-1.25-.53-.4-.22-.8-.67-.58-1.11,.07-.13,.18-.24,.31-.31h0c2.35,.07,4.68,.42,6.95,1.03-.71,1.34-.89,3.79,2.45,4.99,4.86,1.74,0,0,4.46-2.41h0c3.51,1.67,6.73,3.9,9.54,6.6l-1.96,1.43c-2.05,1.38,.67,2.09,.67,2.09h2.81c1.52,0,1.38,0,1.47-.31,1.76,2,3.29,4.2,4.55,6.55Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.45,59.07c.02,.18,.02,.36,0,.53-.27,.94-1.65,.62-2.58,.89-1.96,.62-1.47,4.06-3.39,4.95-.94,.4-2.05,0-2.99,.4-.63,.45-1.2,.97-1.69,1.56-1.01,.9-2.37,1.29-3.7,1.07,.77-6.91,3.54-13.45,7.98-18.81,.35-.06,.72-.06,1.07,0,.7,.25,1.2,.87,1.29,1.6,.13,.74,.13,1.49,0,2.23l1.43-1.07c.64,.42,.81,1.28,.39,1.91-.01,.02-.02,.03-.03,.05-.45,.62-1.34,.71-2.14,.85-.8,.13-1.69,.58-1.74,1.34-.04,.76,.45,1.2,.85,1.69,.4,.49,.8,1.25,.45,1.78l3.12-1.83c.18-.11,.38-.18,.58-.22,.58,.04,1.05,.49,1.11,1.07Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.72,54.22l-.27,.85c.79,.29,1.66,.29,2.45,0,.26-.11,.49-.28,.67-.49,.31-.41,.5-.91,.53-1.43,.09-.67,.09-1.34,0-2.01-.08-.67-.48-1.27-1.07-1.6-.62-.34-1.39-.12-1.74,.49-.27,.58,0,1.29-.31,1.87-.31,.58-.89,.71-1.07,1.2-.12,.48,.16,.96,.64,1.09,.05,.01,.11,.02,.16,.03Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.28,39.15c-1.11,.94-2.9-.31-4.23,.31-1.34,.62-1.07,1.29-1.83,1.43-.42,.02-.83,.02-1.25,0-.45,0-.89,.31-.85,.71,.05,.19,.16,.36,.31,.49l1.11,1.02c.13,.14,.25,.29,.36,.45,.17,.49-.09,1.02-.58,1.19-.01,0-.03,0-.04,.01-.48,.15-.99,.15-1.47,0-.31-.03-.61-.1-.89-.22-.27,0-.45-.58-.27-.85l.31-.31c.29-.28,.42-.68,.36-1.07-.05-.43-.41-.76-.85-.76l-.58,.27-1.92,1.16c-.89,.49-2.01,1.03-2.9,.58-.17-.01-.32-.11-.4-.27v-.58c.07-.23,.07-.48,0-.71,3.6-2.36,7.6-4.03,11.81-4.95,1.37-.31,2.75-.54,4.14-.67h0c.27,1.03,.36,2.18-.36,2.76Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.75,48.47c-.39-.15-.83,.05-.98,.44-.03,.07-.04,.15-.05,.23l.45,.71v-.4c0,.4,.49,.8,.85,.49,.32-.36,.32-.89,0-1.25l-.27-.22Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.92,58.98c-.58-.62-1.6-.4-2.5-.31-.89,.09-2.01-.36-1.96-1.2,.04-.85,.94-1.07,1.69-1.11,.07-1.23-.86-2.28-2.09-2.36-.08,0-.15,0-.23,0,.31,.71,.31,1.52,0,2.23-.28,.68-1.06,1.01-1.74,.73-.04-.02-.09-.04-.13-.06-1.11-.85,.27-3.07-.8-3.97-.58-.27-1.25-.27-1.83,0-2.14,.49-4.46,1.25-5.3,3.3,0,.22-1.78,0-2.32,0s-.85,1.65-.94,2.23c-.13,.31-.13,.67,0,.98,0,.36,.58,.71,.4,1.07-.18,.36-.45,.27-.62,.49-.18,.22,1.16,2.23,1.6,2.45,.45,.22,1.69,0,2.54,.4,.63,.46,.93,1.25,.76,2.01h-.8c.43,1.1,.06,2.34-.89,3.03,1.15-.23,2.34,.14,3.16,.98,0,0,.4,.45,.67,.45,.18-.03,.35-.1,.49-.22,.9-.53,1.54-1.4,1.78-2.41h.89c0-.49,0-1.29-.53-1.11-.53,.18,0,0-.31,.27-.31,.27-1.16,0-1.2-.76,.03-.59,.25-1.15,.62-1.6,.22-.27,.4-.58,.62-.89,.41-.73,1.08-1.29,1.87-1.56,1.38-.31,2.5,1.16,3.16,2.41,.27,.53,.4,1.38,0,1.47-.4,.09-.62-.22-.85,0-.22,.22,0,.71-.45,.94s-.49,0-.71,0-.49,1.02,0,1.56c.49,.53,.67-.31,1.02-.53,.36-.22,1.69,.36,2.5,0,.8-.36,.67-.67,.98-.98s2.41-1.02,2.54-2.18c.13-1.16-.45-1.25-.58-1.92-.13-.67,.31-2.94-.53-3.79Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.63,67.67c.37,.09,.75,.09,1.11,0,.53,0,2.27,.49,1.56,1.47-.71,.98-1.83-1.11-2.76-.58,.53,0,.49,1.03,.22,1.56-.27,.53-.58,1.2-.22,1.69,.71-.31,1.43,.36,2.23,.53,.8,.18,2.01-.58,3.03-.4v-1.16c0-.4,.76-.31,1.11-.58,.36-.27,.8-.58,1.16-.31,.36,.27,0-.89,0-1.29-.35-.31-.66-.65-.94-1.02-.22-.4,0-1.03,.27-1.16,.27-.13,.85,0,1.2,0,.29-.18,.46-.5,.45-.85-.02-.34-.02-.68,0-1.03h-.85c.09,.37-.13,.74-.49,.85-.35,.09-.72,.09-1.07,0,.14-1.04,0-2.1-.4-3.07h-1.11c0,.45-.49,.71-.94,.71-.42-.09-.8-.29-1.11-.58-.22-.22-.49-.45-.8-.36-.31,.09-.58,.58-.53,1.02,0,1.6-.67,1.2-1.34,2.09-.59,.75-.49,1.82,.22,2.45Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.39,83.09c-.89,.15-1.81,.03-2.63-.36-.36-.22-.8-.49-1.2-.27-.36,.23-.53,.66-.45,1.07,0,.36,.4,.71,.53,1.11,.51,1.04,.51,2.26,0,3.3-1.75,.34-3.57-.08-4.99-1.16-.15-.15-.28-.32-.4-.49-.31-.71,.67-1.52,.49-2.23-.18-.71-1.56-1.25-1.11-1.92,.45-.67,.85-.27,1.25-.45,.46-.23,.65-.79,.42-1.25l-.02-.04c-1.07-.5-2.34-.14-2.99,.85-.76,0-.98-1.11-1.02-1.83-.04-.71-.53-1.78-1.29-1.52-.27,.12-.45,.38-.49,.67-.58,1.69,.8,3.3,2.05,4.46,.33,.25,.56,.62,.62,1.02,0,.45-.27,.94-.71,.85l1.56,1.74c.13,.17,.2,.37,.22,.58,.03,.13,.03,.27,0,.4-.43,.57-.83,1.17-1.2,1.78-1.48-2.81-2.56-5.81-3.21-8.91-.61-2.83-.89-5.71-.85-8.6,.25-.38,.58-.68,.98-.89,.49,0,1.07,0,1.52-.27,1.11-.31,1.6-1.74,2.72-2.18,.9-.31,1.89-.02,2.5,.71,.57,.78,.77,1.78,.53,2.72-.28,.71-.37,1.47-.27,2.23,.45,1.29,2.05,1.43,3.39,1.38-.14,.82,.27,1.64,1.02,2.01,.7,.23,1.46-.16,1.68-.86,.03-.08,.04-.17,.06-.25,.85,0,1.92,.53,1.92,1.43-.16,.55-.51,1.02-.98,1.34-.36,.45-.67,1.11-.31,1.56,.36,.45,1.56,0,1.87,.76,.31,.76-.62,1.43-1.2,1.52Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.44,108.67h-1.16c-.24-.71-.16-1.49,.22-2.14,.49-.71,1.38-1.2,1.78-2.01,.18-.54,.42-1.07,.71-1.56,.76-1.2,2.54-1.11,3.97-.89-.36-.67-.1-1.51,.57-1.87h0c.71-.28,1.47-.4,2.23-.36,.74,.08,1.48-.15,2.05-.62,0-.22,.36-.53,.62-.62h.62l4.01,.49c0-.98-1.07-1.52-2.01-1.6-.94-.09-2.05,0-2.5-.98-1.06,1.72-3.15,2.5-5.08,1.92-.11,.05-.24,.05-.36,0-.4-.53,.98-1.2,.53-1.65l-1.92-.76c-.27,0-.58-.22-.71-.49-.13-.27,0-.98,.4-1.47,.4-.49-.22-1.96-.49-2.94-.27-.98,0-2.41,1.11-2.41h.67c.18,0,.45-.71,.53-1.11,.27-1.2,1.47-1.92,2.5-2.63,.3-.24,.59-.51,.85-.8,.96-.91,1.53-2.15,1.6-3.48-.87,.53-1.62,1.25-2.18,2.09-.71,.8-1.78,1.47-2.72,.98,.17,1.29-.59,2.53-1.83,2.94-1.27,.29-2.56-.39-3.03-1.6-.24-.35-.24-.81,0-1.16,.36-.11,.75-.11,1.11,0,1.19,.08,2.32-.5,2.94-1.52-1.38,.02-2.69-.65-3.48-1.78-.7-1.23-.33-2.79,.85-3.57h-.89c.27-1.13,1.18-1.98,2.32-2.18h1.65c.55-.1,.97-.55,1.03-1.11-.63-.4-.98-1.13-.89-1.87,.15-.62,.58-1.13,1.16-1.38-.33-.01-.61-.25-.67-.58,0-.46,.31-.86,.76-.98,.47-.11,.96-.11,1.43,0,1.21,.08,2.34,.63,3.16,1.52,.41,.78,.58,1.66,.49,2.54v3.48c-.15,1.14,.23,2.29,1.03,3.12,.54,.34,1.19,.5,1.83,.45,1.87,.01,3.72-.37,5.44-1.11,.91-.32,1.69-.95,2.18-1.78,.4-.85,.55-1.79,.45-2.72,0-1.87,.36-4.86-1.56-6.02-.56-.36-1.27-.36-1.83,0-.36,.27-.62,.67-1.02,.8-.4,.13-1.29-.22-1.83,0-.53,.22-.49,.58-.76,.94-.18,.39-.62,.58-1.03,.45-.4-.22,0-.89,0-1.38s-.76-1.92-.58-2.9c.18-.98,1.11-1.52,1.74-2.23,.59-.66,1.09-1.39,1.47-2.18,.58-.27,1.25,0,1.78,.53,.5,.43,1.2,.57,1.83,.36,.49,.62-.27,1.78,.45,2.27h.31c.09,.24,.09,.51,0,.76,0,.89,.45,1.96,1.34,2.23h.36s0,0,0-.27c.2-1.17-.07-2.37-.76-3.34-.12-.21-.23-.44-.31-.67-.06-.22-.06-.45,0-.67,.06-.26,.15-.52,.27-.76-.03-.15-.03-.3,0-.45,.31-.27,.76,0,1.11,0,.35-.07,.68-.2,.98-.4,.45-.2,.97-.2,1.43,0,.31,1.07,.62,2.18,.89,3.3,4.49,19.6-7.64,39.16-27.18,43.85Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.01,97.13c-.16,.73-.16,1.49,0,2.23-.85,.52-1.88,.68-2.85,.45-.71,1.91,.13,4.05,1.96,4.95-.6,.49-1.4,.64-2.14,.4-.69-.3-1.32-.73-1.87-1.25l-4.46-3.43c-.71,.27-.27,1.38,.45,1.74,.71,.36,1.56,.4,1.92,1.07,.36,.67,0,2.01,.4,2.72,.36,.26,.75,.48,1.16,.67,.67,.51,.97,1.37,.76,2.18v.58c-5.61-.27-11.08-1.87-15.95-4.68h0c.02-.28,.02-.56,0-.85,0-1.34,1.25-2.23,2.27-3.03,1.15-.68,1.88-1.88,1.96-3.21-1.74,.45-2.41,2.63-3.88,3.57-.39,.25-.81,.44-1.25,.58-.74,.38-1.44,.82-2.09,1.34-3.61-2.45-6.74-5.55-9.23-9.14,.72-.96,1.07-2.15,.98-3.34,.4-.49,1.02,.4,1.6,.45s1.02-.85,1.69-.89c.67-.04,.94,1.92,1.96,2.27,1.02,.36,1.34-.58,2.05-.67,.71-.09,1.56,.58,2.41,.31,2.45-.76,.62-3.43,.98-4.95,.22-.71,1.11-.85,1.69-1.2,.86-.58,1.37-1.55,1.38-2.58-.03-1-.19-1.99-.49-2.94-.38-.92-.3-1.96,.22-2.81,.94-1.02,2.76-.36,4.06-1.02,1.29-.67,1.29-1.92,2.23-2.63,.85-.59,1.86-.89,2.9-.85,.27-.04,.54-.04,.8,0,.49,.27,.4,1.02,.31,1.52-.32,1.53-.78,3.02-1.38,4.46,1.16,.53,2.76,1.02,3.61,0,.15-.28,.35-.54,.58-.76,.48-.25,1.04-.25,1.52,0,.4,.89,.85,1.74,1.29,2.54-2.29-.14-4.41,1.23-5.21,3.39-.05,.32-.17,.62-.36,.89-.31,.36-.77,.56-1.25,.53-1.47-.2-2.89-.66-4.19-1.38-1.43-.45-3.43,0-3.79,1.25,1.16-.4,2.14,.8,3.25,1.25,.65,.21,1.32,.33,2.01,.36,1.66,.15,3.29,.57,4.81,1.25,1.14-.46,1.92-1.53,2.01-2.76,1.09,1.53,2.84,2.46,4.72,2.5-.44,1.45-.44,3,0,4.46,.53,1.07,1.6,2.05,1.56,3.25-.57,.19-.99,.66-1.11,1.25Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197.51,440.51c-3.21-4.03-8.7-6.12-13.79-5.24,.11-5.84-2.39-11.68-6.68-15.64s-10.31-5.98-16.12-5.41c-.2-9.36-9.37-17.45-18.66-16.68v-85.33h-49.89v85.33c-9.29-.77-18.46,7.32-18.66,16.68-5.81-.57-11.83,1.45-16.12,5.41-4.29,3.96-6.78,9.8-6.68,15.64-5.08-.88-10.57,1.2-13.79,5.24-3.21,4.03-4.02,9.85-2.02,14.61H199.54c2-4.76,1.19-10.57-2.02-14.61Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.51,440.51c-3.21-4.03-8.7-6.12-13.79-5.24,.11-5.84-2.39-11.68-6.68-15.64s-10.31-5.98-16.12-5.41c-.2-9.36-9.37-17.45-18.66-16.68v-85.33h-49.89v85.33c-9.29-.77-18.46,7.32-18.66,16.68-5.81-.57-11.83,1.45-16.12,5.41-4.29,3.96-6.78,9.8-6.68,15.64-5.08-.88-10.57,1.2-13.79,5.24-3.21,4.03-4.02,9.85-2.02,14.61H199.54c2-4.76,1.19-10.57-2.02-14.61Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Rocket--inject-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.04,177.81s-24.26,12.23-31.56,42.86c-5.32,22.34-3.71,64.5,5.88,67.89s10.66-22.72,10.74-32c.08-9.28,8.78-20.61,16.53-21.29,0,0,1.52-48.99-1.59-57.46Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.67,183.89c-5.74,2.19-10.45,6.38-14.27,11.08-4.07,5.16-7.42,10.86-9.95,16.92-2.81,6.48-4.86,13.27-6.1,20.22-1.16,7.33-1.73,14.73-1.7,22.15-.13,9.07-.35,18.52,3.19,27.07,.14,.34,.7,.19,.56-.15-3.06-7.45-3.25-15.59-3.19-23.53,.06-7.49,.18-15.02,1.24-22.45,1.9-13.2,6.71-26.55,14.54-37.41,4.06-5.63,9.27-10.83,15.86-13.34,.35-.14,.2-.69-.15-.56h-.02Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.14,177.81s24.26,12.23,31.56,42.86c5.32,22.34,3.71,64.5-5.88,67.89-9.59,3.38-10.66-22.72-10.74-32-.08-9.28-8.78-20.61-16.52-21.29,0,0-1.52-48.99,1.59-57.46Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.36,184.44c5.77,2.2,10.48,6.48,14.28,11.26,3.97,5.13,7.23,10.76,9.7,16.76,2.77,6.45,4.78,13.2,5.99,20.11,1.27,7.28,1.52,14.67,1.6,22.05,.12,8.91,.31,18.16-3.14,26.56-.14,.34,.42,.49,.56,.15,3.1-7.55,3.26-15.81,3.19-23.86-.06-7.59-.2-15.21-1.3-22.73-1.06-7.16-2.98-14.17-5.71-20.88-2.37-6.06-5.51-11.79-9.34-17.05-4.05-5.48-9.21-10.44-15.67-12.91-.35-.14-.5,.42-.15,.56h0Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,270.91H79.78s-12.27-47.16-7.46-100.04c1.3-14.01,4.85-27.72,10.53-40.6,.08-.2,.17-.4,.26-.59,1.4-3.19,2.88-6.2,4.4-9.06,5.95-11.27,13.38-21.7,22.08-31.02,1.93-2.2,5.28-2.42,7.49-.49,.17,.15,.34,.32,.49,.49,8.98,9.61,16.6,20.41,22.65,32.09,1.52,2.93,2.99,6.02,4.39,9.26l.25,.57c5.35,12.52,8.73,25.79,9.99,39.35,4.8,52.91-8.03,100.04-8.03,100.04Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.8,270.91H79.78s-12.27-47.16-7.46-100.04c1.3-14.01,4.85-27.72,10.53-40.6,.08-.2,.17-.4,.26-.59,1.4-3.19,2.88-6.2,4.4-9.06,5.95-11.27,13.38-21.7,22.08-31.02,1.93-2.2,5.28-2.42,7.49-.49,.17,.15,.34,.32,.49,.49,8.98,9.61,16.6,20.41,22.65,32.09,1.52,2.93,2.99,6.02,4.39,9.26l.25,.57c5.35,12.52,8.73,25.79,9.99,39.35,4.8,52.91-8.03,100.04-8.03,100.04Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.13,
    y: 264.19,
    width: 50.26,
    height: 0.77,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.33,288.86H80.57c-4.83-6.95,.28-17.95,.28-17.95h66.1s5.08,8.98,1.37,17.95Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.21,295.16h-33.88c-2.39-3.48,.14-8.98,.14-8.98h33.05s2.54,4.48,.69,8.98Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.23,295.16h-33.78c-6.84,3.63-23.85,12.3-21.47,26.98h77.6c2.38-14.68-15.5-23.36-22.34-26.98Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.06,
    y: 319.04,
    width: 82.85,
    height: 6.39,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.2,121.7c-6.11,4.37-15.46,9.27-26.63,9.27-9.69-.06-19-3.76-26.08-10.37,.64-1.21,1.28-2.38,1.93-3.53l.31-.53c5.53-9.73,12.19-18.78,19.84-26.95,1.93-2.2,5.28-2.42,7.49-.49,.17,.15,.34,.32,.49,.49,7.67,8.19,14.34,17.27,19.88,27.03l.31,.55c.84,1.47,1.65,2.99,2.46,4.54Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.75,117.18c-1.96,1.41-4.04,2.64-6.22,3.69-7.66,3.7-16.28,4.94-24.68,3.54-6.29-1.08-12.26-3.59-17.43-7.32l.31-.53c2.1,1.53,4.35,2.85,6.7,3.95,7.65,3.61,16.24,4.72,24.56,3.19,5.93-1.12,11.55-3.53,16.45-7.06l.31,.54Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.69,179.31c-3.07-31.02-5.47-43.44-5.75-44.8,1.16-.63,2.24-1.27,3.19-1.89,.58-.36,1.14-.73,1.68-1.09l-.25-.57c-.57,.38-1.15,.8-1.76,1.15-6.38,4.03-16.64,8.84-28.99,8.84-9.73,0-19.24-2.98-27.22-8.55-1.32-.91-2.49-1.83-3.53-2.7-.09,.19-.18,.39-.26,.59,1.01,.85,2.15,1.72,3.42,2.61,.8,.56,1.7,1.14,2.65,1.72-.34,1.72-2.71,14.24-5.73,44.68-2.39,23.78-.21,47.44,2.01,63.1,1.32,9.61,3.13,19.15,5.44,28.57,.03,.13,.15,.22,.28,.22h.07c.15-.04,.24-.2,.21-.35-2.3-9.41-4.11-18.92-5.43-28.52-2.22-15.62-4.36-39.23-2.01-62.95,2.92-29.48,5.23-42.12,5.68-44.46,7.4,4.39,15.84,6.71,24.45,6.7,8.94-.11,17.71-2.43,25.53-6.75,.4,2.03,2.74,14.6,5.71,44.56,2.35,23.72,.21,47.32-2.01,62.95-1.31,9.59-3.12,19.11-5.43,28.52-.04,.15,.06,.31,.21,.35h.07c.13,0,.25-.09,.28-.22,2.31-9.42,4.12-18.96,5.44-28.57,2.25-15.69,4.4-39.35,2.04-63.12Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,212.24c-12.26,0-22.21-9.93-22.21-22.2,0-12.26,9.93-22.21,22.2-22.21,12.26,0,22.21,9.93,22.21,22.2v.02c-.01,12.25-9.94,22.19-22.2,22.2Zm0-43.82c-11.94,0-21.62,9.68-21.62,21.62s9.68,21.62,21.62,21.62,21.62-9.68,21.62-21.62h0c-.01-11.94-9.69-21.61-21.62-21.62Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.66,190.04c0,9.29-7.53,16.81-16.81,16.81h-.39c-2.85-.06-5.63-.84-8.08-2.28-1.9-1.11-3.56-2.58-4.9-4.32-2.24-2.93-3.45-6.51-3.44-10.2,0-.65,.04-1.31,.11-1.95,.92-7.73,7.01-13.82,14.74-14.74,.65-.07,1.31-.11,1.96-.11,9.13,.01,16.58,7.29,16.8,16.41,0,.13,0,.26,0,.38Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.04,176.7l-23.56,23.56c-2.24-2.93-3.45-6.51-3.44-10.2,0-.65,.04-1.31,.11-1.95l14.74-14.74c.65-.07,1.31-.11,1.96-.11,3.68,0,7.26,1.2,10.19,3.44Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.65,189.65l-17.2,17.2c-2.85-.06-5.63-.84-8.08-2.28l22.99-22.98c1.44,2.45,2.23,5.23,2.29,8.07Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.51,
    y: 362.68,
    width: 96.59,
    height: 92.64,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.51,
    y: 362.68,
    width: 96.59,
    height: 92.64,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.25,
    y: 362.68,
    width: 65.83,
    height: 92.64,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 367.42,
    width: 59.25,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 381.76,
    width: 59.25,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 396.1,
    width: 59.25,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 410.44,
    width: 59.25,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 424.78,
    width: 59.25,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.54,
    y: 439.13,
    width: 59.25,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.96,
    y: 367.42,
    width: 23.85,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.96,
    y: 381.76,
    width: 23.85,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.96,
    y: 396.1,
    width: 23.85,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.96,
    y: 410.44,
    width: 23.85,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.96,
    y: 424.78,
    width: 23.85,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.96,
    y: 439.13,
    width: 23.85,
    height: 11.47,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.51,
    y: 368.91,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.85,
    y: 368.91,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.19,
    y: 368.91,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.53,
    y: 368.91,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.86,
    y: 368.91,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.51,
    y: 383.25,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.85,
    y: 383.25,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.19,
    y: 383.25,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.53,
    y: 383.25,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.86,
    y: 383.25,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.51,
    y: 397.6,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.85,
    y: 397.6,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.19,
    y: 397.6,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.53,
    y: 397.6,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.86,
    y: 397.6,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.51,
    y: 411.94,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.85,
    y: 411.94,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.19,
    y: 411.94,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.53,
    y: 411.94,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.86,
    y: 411.94,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.51,
    y: 426.28,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.85,
    y: 426.28,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.19,
    y: 426.28,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.53,
    y: 426.28,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.86,
    y: 426.28,
    width: 1.38,
    height: 8.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.51,
    y: 440.62,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.85,
    y: 440.62,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.19,
    y: 440.62,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.53,
    y: 440.62,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.86,
    y: 440.62,
    width: 1.38,
    height: 8.49,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,373.15c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,373.15c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,373.15c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,387.49c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,387.49c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,387.49c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,401.84c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,401.84c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,401.84c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,416.18c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,416.18c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,416.18c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,430.52c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,430.52c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,430.52c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,444.87c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,444.87c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,444.87c0,.78-.63,1.41-1.41,1.41s-1.41-.63-1.41-1.41,.63-1.41,1.41-1.41h0c.78,0,1.41,.63,1.41,1.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.51,
    y: 362.68,
    width: 30.74,
    height: 92.64,
    style: {
      opacity: 0.3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bars--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 349.85,
    y: 385.67,
    width: 48.64,
    height: 69.52,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.65,
    y: 385.67,
    width: 15.83,
    height: 69.65,
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 285.65,
    y: 405.78,
    width: 43.61,
    height: 49.54,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.07,
    y: 405.78,
    width: 14.2,
    height: 49.54,
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 417.01,
    y: 345.34,
    width: 47.54,
    height: 109.98,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.07,
    y: 345.34,
    width: 15.48,
    height: 109.98,
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech_Bubble--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M427.08,220.46h-36.6c-3.31,0-5.99,2.68-5.99,5.99v19.76c0,3.31,2.68,5.99,5.99,5.99h8.75l.07,5.98,6.59-5.98h21.18c3.31,0,5.99-2.68,5.99-5.99v-19.76c0-3.31-2.68-5.99-5.99-5.99Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M404.28,233.2l-5.77,2.7,5.77,2.69v2.17l-7.71-3.74v-2.26l7.71-3.74v2.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.84,234.77v2.26l-7.71,3.74v-2.17l5.77-2.69-5.77-2.7v-2.17l7.71,3.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "410.55 229.52 406.79 242.51 408.67 242.51 412.43 229.52 410.55 229.52",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M418.64,219.11h-18.8c-.14,0-.25-.11-.25-.25s.11-.25,.25-.25h18.8c.14,0,.25,.11,.25,.25s-.11,.25-.25,.25Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.82,219.12h-2.97c-.14,0-.25-.11-.25-.25s.11-.25,.25-.25h2.97c.14,0,.25,.11,.25,.25s-.11,.25-.25,.25Z",
    style: {
      fill: "#0F7D3B"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab_2--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 322.81,
    y: 83.46,
    width: 111.08,
    height: 93.4,
    rx: 4.94,
    ry: 4.94,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.81,
    y: 83.46,
    width: 111.08,
    height: 93.4,
    rx: 4.94,
    ry: 4.94,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.44,83.46h101.91c2.51,0,4.55,2.04,4.55,4.55v11.74h-111.08v-11.66c0-2.55,2.07-4.63,4.63-4.63Z",
    style: {
      fill: "#0F7D3B"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M427.62,92.79c0,1.96-1.59,3.56-3.56,3.56s-3.56-1.59-3.56-3.56,1.59-3.56,3.56-3.56,3.56,1.59,3.56,3.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.51,92.79c0,1.96-1.59,3.56-3.56,3.56s-3.56-1.59-3.56-3.56,1.59-3.56,3.56-3.56,3.56,1.59,3.56,3.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.41,92.79c0,1.96-1.59,3.56-3.56,3.56s-3.56-1.59-3.56-3.56,1.59-3.56,3.56-3.56,3.56,1.59,3.56,3.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 347.81,
    y: 113.36,
    width: 56.97,
    height: 3.32,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.7,
    y: 120.54,
    width: 40.77,
    height: 3.32,
    style: {
      fill: "#263238",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.97,
    y: 113.36,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.65,
    y: 113.36,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.81,
    y: 128.5,
    width: 56.97,
    height: 3.32,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.97,
    y: 128.5,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.65,
    y: 128.5,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.81,
    y: 160.07,
    width: 56.97,
    height: 3.32,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.97,
    y: 160.07,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.81,
    y: 136.49,
    width: 56.97,
    height: 3.32,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.97,
    y: 136.49,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#263238",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.65,
    y: 136.49,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#263238",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.93,
    y: 120.67,
    width: 27.08,
    height: 3.32,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.81,
    y: 143.45,
    width: 40.77,
    height: 3.32,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.04,
    y: 143.58,
    width: 27.08,
    height: 3.32,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.81,
    y: 150.66,
    width: 20.38,
    height: 3.32,
    style: {
      fill: "#263238",
      opacity: 0.6
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab_1--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.14,148.5v147.15c0,2.54,2.06,4.59,4.59,4.59h202.02V148.51c0-1.36-1.1-2.46-2.46-2.46H167.59c-1.36,0-2.45,1.1-2.45,2.45Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.14,
    y: 146.05,
    width: 206.61,
    height: 154.2,
    rx: 4.47,
    ry: 4.47,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69,146.05h201.98c1.15,0,2.08,.93,2.08,2.08v10.3H165.14v-9.82c0-1.41,1.14-2.55,2.55-2.55Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61,151.72c.35,1.85-1.24,3.45-3.09,3.1-1.03-.19-1.87-1.04-2.06-2.06-.35-1.85,1.24-3.45,3.09-3.1,1.03,.2,1.87,1.04,2.06,2.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.15,151.72c.35,1.85-1.24,3.45-3.09,3.1-1.03-.19-1.87-1.04-2.06-2.06-.35-1.85,1.24-3.45,3.09-3.1,1.03,.2,1.87,1.04,2.06,2.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.68,151.72c.35,1.85-1.24,3.45-3.09,3.1-1.03-.19-1.87-1.04-2.06-2.06-.35-1.85,1.24-3.45,3.09-3.1,1.03,.2,1.87,1.04,2.06,2.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M356.56,234.51c-2.46-6.47-5.51-12.75-9.11-18.75-1.98-3.31-4.46-6.78-8.39-7.92-4.85-1.41-10.09,1.34-13.33,4.94-3.25,3.59-5.23,8.01-8.35,11.7-3.12,3.69-8.07,6.72-13.04,5.74-5.03-.99-9.09-5.85-14.14-4.93-4.98,.91-7.46,7.08-12.52,7.48-3.71,.29-6.67-2.7-8.71-5.55-3.64-5.07-6.55-10.65-11.06-15.1s-11.23-7.69-17.68-6.28c-4.41,.96-7.97,3.91-10.91,7.08-4.77,5.14-8.45,11.12-10.78,17.52-.98,2.71-2.17,5.91-5.17,6.69-2.76,.71-5.55-1.13-7.24-3.25-1.69-2.12-2.84-4.65-5.02-6.35-4.54-3.54-11.93-1.95-16.11,1.95-4.18,3.9-5.95,9.39-7.58,14.64v22.93h179.22l-.06-32.53Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.56,234.51c-2.46-6.47-5.51-12.75-9.11-18.75-1.98-3.31-4.46-6.78-8.39-7.92-4.85-1.41-10.09,1.34-13.33,4.94-3.25,3.59-5.23,8.01-8.35,11.7-3.12,3.69-8.07,6.72-13.04,5.74-5.03-.99-9.09-5.85-14.14-4.93-4.98,.91-7.46,7.08-12.52,7.48-3.71,.29-6.67-2.7-8.71-5.55-3.64-5.07-6.55-10.65-11.06-15.1s-11.23-7.69-17.68-6.28c-4.41,.96-7.97,3.91-10.91,7.08-4.77,5.14-8.45,11.12-10.78,17.52-.98,2.71-2.17,5.91-5.17,6.69-2.76,.71-5.55-1.13-7.24-3.25-1.69-2.12-2.84-4.65-5.02-6.35-4.54-3.54-11.93-1.95-16.11,1.95-4.18,3.9-5.95,9.39-7.58,14.64v22.93h179.22l-.06-32.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.92,234.41c-1.72-4.5-3.7-8.9-5.95-13.16-1.96-3.71-3.98-7.79-6.98-10.79-2.66-2.66-6.2-3.89-9.92-3.13-3.95,.8-7.28,3.42-9.74,6.52-2.81,3.55-4.76,7.75-7.86,11.08s-7.61,5.88-12.21,4.89c-3.78-.81-6.72-3.63-10.41-4.67-3.3-.93-6.11,.3-8.61,2.43-2.66,2.27-5.39,5.54-9.31,4.7-4.38-.93-7.02-5.69-9.27-9.13-4.65-7.09-9.56-14.54-18.09-17.2-3.84-1.2-7.92-1.09-11.6,.59-3.86,1.76-6.97,4.87-9.66,8.07-2.85,3.38-5.29,7.12-7.2,11.11-.89,1.86-1.6,3.77-2.34,5.68-.68,1.78-1.55,3.78-3.24,4.82-2.23,1.36-4.83,.45-6.68-1.11-1.66-1.4-2.7-3.33-3.95-5.07-2.1-2.93-4.91-4.73-8.57-4.85-3.39-.11-6.87,1.09-9.56,3.14-3.17,2.43-5.21,6.02-6.67,9.67-.79,1.97-1.42,3.99-2.05,6.01-.14,.46,.58,.66,.72,.2,2.4-7.73,5.78-16.38,14.72-18.05,4.27-.8,8.07,.59,10.65,4.1,2.14,2.91,3.98,6.52,7.88,7.29,3.45,.67,5.74-1.89,7-4.77,.76-1.75,1.34-3.57,2.11-5.32,.9-2.03,1.93-3.99,3.09-5.89,2.33-3.83,5.16-7.46,8.46-10.5s7.32-5.26,11.91-5.19c9.43,.14,15.9,7.75,20.67,14.98,3.28,4.98,8.37,15.13,15.94,11.6,2.95-1.37,4.84-4.23,7.61-5.86,3.71-2.18,7.32-.33,10.7,1.55s6.44,3.18,10.19,2.36,7.1-3.43,9.49-6.44c2.8-3.53,4.76-7.67,7.8-11.02,2.79-3.07,6.91-5.52,11.19-5.17s7.39,3.93,9.57,7.46c2.45,3.96,4.61,8.11,6.55,12.34,1.04,2.28,2.01,4.6,2.9,6.94,.17,.45,.9,.25,.72-.2h0Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.98,184.06v82.98c0,.2,.17,.38,.38,.38h172c2.3,0,4.68,.19,6.97,0,.1,0,.2,0,.3,0,.48,0,.48-.75,0-.75H180.04c-.73,0-1.67-.16-2.39,0-.09,.02-.2,0-.3,0l.38,.38v-82.98c0-.48-.75-.48-.75,0h0Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4,182.33v84.71c0,.48,.75,.48,.75,0v-84.71c0-.48-.75-.48-.75,0h0Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.54,182.33v84.71c0,.48,.75,.48,.75,0v-84.71c0-.48-.75-.48-.75,0h0Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.68,182.33v84.71c0,.48,.75,.48,.75,0v-84.71c0-.48-.75-.48-.75,0h0Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.82,182.33v84.71c0,.48,.75,.48,.75,0v-84.71c0-.48-.75-.48-.75,0h0Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.95,182.33v84.71c0,.48,.75,.48,.75,0v-84.71c0-.48-.75-.48-.75,0h0Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.25,182.33v84.71c0,.48,.75,.48,.75,0v-84.71c0-.48-.75-.48-.75,0h0Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93,248.79h179.7c.48,0,.48-.75,0-.75H176.93c-.48,0-.48,.75,0,.75h0Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93,227.8h179.7c.48,0,.48-.75,0-.75H176.93c-.48,0-.48,.75,0,.75h0Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93,206.81h179.7c.48,0,.48-.75,0-.75H176.93c-.48,0-.48,.75,0,.75h0Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93,185.81h179.7c.48,0,.48-.75,0-.75H176.93c-.48,0-.48,.75,0,.75h0Z",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 188.31,
    cy: 279.76,
    r: 2.83,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.85,278.67h51.59c.48,0,.48-.75,0-.75h-51.59c-.48,0-.48,.75,0,.75h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.85,282.11h28.41c.48,0,.48-.75,0-.75h-28.41c-.48,0-.48,.75,0,.75h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.19,
    cy: 279.76,
    r: 2.83,
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.73,278.67h51.59c.48,0,.48-.75,0-.75h-51.59c-.48,0-.48,.75,0,.75h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.73,282.11h28.41c.48,0,.48-.75,0-.75h-28.41c-.48,0-.48,.75,0,.75h0Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_2--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "365.83 431.85 369.06 450.49 361.4 453.58 355.03 434.02 365.83 431.85",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M366.68,448.96c-.52,1.4-1.76,2.08-3.09,1.82l-.89-1.26c-.77-1.08-1.84-1.47-3.01-.68-.58,.39-1.07,1.5-1.01,2.87,.1,2.47-.88,4.05-.88,4.05,0,0-4.19,5.63-5.89,7.27-1.01,.98-2.34,2.35-2.54,4.07-.06,.49-.06,1.04,0,1.65,.06,.5,.54,1.45,.55,1.47l14.2-7.22s1.02-1.58,1.65-1.87c1.12-.52,2.09,.19,2.09,.19l5.18-2.59s-.31-.85-.75-2.08h0c-.2-.56-.43-1.19-.67-1.86-1.04-2.87-2.24-6.54-2.54-7.35-.53-1.42-2.4,1.5-2.4,1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.47,458.68c.03-.09,.13-.15,.23-.14,.45,.04,.88,.2,1.26,.47,.2,.15-.01,.49-.22,.34-.34-.25-.72-.38-1.11-.42-.13-.01-.21-.13-.16-.25h0Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,457.53c.03-.09,.13-.15,.23-.14,.45,.04,.88,.2,1.26,.47,.2,.15-.01,.49-.22,.34-.34-.25-.72-.38-1.11-.42-.13-.01-.21-.13-.16-.25h0Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.12,456.41c.03-.09,.13-.15,.23-.14,.45,.04,.88,.2,1.26,.47,.2,.15-.01,.49-.22,.34-.34-.25-.72-.38-1.11-.42-.13-.01-.21-.13-.16-.25h0Z",
    style: {
      fill: "#0F7D3B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M349.35,468c0,.25,.02,.52,.05,.8,.06,.5,.54,1.45,.55,1.47l14.2-7.22s1.02-1.58,1.65-1.87c1.12-.52,2.09,.19,2.09,.19l5.18-2.59s-.31-.85-.75-2.08h0l-.11-.31-22.86,11.61Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.54,456.67l-.23-.05c-.38-.08-1.67-.38-2.13-.73-.48-.36-.79-.86-.85-1.38-.04-.29,.03-.67,.33-.84,.29-.17,.62-.06,.86,.07,.46,.24,.88,.65,1.22,1.2,.3,.48,.51,1.01,.72,1.52l.09,.22Zm-2.56-2.84c-.07,0-.14,.01-.2,.05-.19,.11-.23,.39-.2,.6,.05,.45,.33,.89,.75,1.21,.3,.23,1.09,.47,1.81,.63-.17-.43-.36-.87-.61-1.26-.32-.51-.7-.89-1.12-1.11-.1-.05-.26-.12-.42-.12Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.29,456.72l-.02-.24c-.04-.55-.08-1.12-.01-1.68,.07-.64,.26-1.19,.58-1.61,.22-.3,.47-.45,.75-.43,.34,.03,.56,.34,.66,.62,.17,.49,.11,1.08-.16,1.61-.27,.52-1.29,1.34-1.6,1.59l-.19,.15Zm1.25-3.71c-.22,0-.4,.21-.5,.33-.29,.39-.46,.89-.53,1.49-.05,.46-.03,.94,0,1.4,.57-.46,1.18-1.02,1.35-1.36,.24-.47,.3-.99,.15-1.42-.07-.2-.23-.43-.44-.45h-.03Z",
    style: {
      fill: "#0F7D3B"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "341.21 427.86 344.44 446.5 336.78 449.59 330.42 430.04 341.21 427.86",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M342.07,444.97c-.52,1.4-1.76,2.08-3.09,1.82l-.89-1.26c-.77-1.08-1.84-1.47-3.01-.68-.58,.39-1.07,1.5-1.02,2.87,.1,2.47-.88,4.05-.88,4.05,0,0-4.19,5.63-5.89,7.27-1.01,.98-2.34,2.35-2.54,4.07-.06,.49-.06,1.04,0,1.65,.06,.5,.54,1.45,.55,1.47l14.2-7.22s1.02-1.58,1.65-1.87c1.12-.52,2.09,.19,2.09,.19l5.18-2.59s-.31-.85-.75-2.08h0c-.2-.56-.43-1.19-.67-1.86-1.04-2.87-2.24-6.54-2.54-7.35-.53-1.42-2.4,1.5-2.4,1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86,454.69c.03-.09,.13-.15,.23-.14,.45,.04,.88,.2,1.26,.47,.2,.15-.01,.49-.22,.34-.34-.25-.72-.38-1.11-.42-.13-.01-.21-.13-.16-.25h0Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.65,453.54c.03-.09,.13-.15,.23-.14,.45,.04,.88,.2,1.26,.47,.2,.15-.01,.49-.22,.34-.34-.25-.72-.38-1.11-.42-.13-.01-.21-.13-.16-.25h0Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.5,452.42c.03-.09,.13-.15,.23-.14,.45,.04,.88,.2,1.26,.47,.2,.15-.01,.49-.22,.34-.34-.25-.72-.38-1.11-.42-.13-.01-.21-.13-.16-.25h0Z",
    style: {
      fill: "#0F7D3B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.73,464.02c0,.25,.02,.52,.05,.8,.06,.5,.54,1.45,.55,1.47l14.2-7.22s1.02-1.58,1.65-1.87c1.12-.52,2.09,.19,2.09,.19l5.18-2.59s-.31-.85-.75-2.08h0l-.11-.31-22.86,11.61Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.92,452.69l-.23-.05c-.38-.08-1.67-.38-2.13-.73-.48-.36-.79-.86-.85-1.38-.04-.29,.03-.67,.33-.84,.29-.17,.62-.06,.86,.07,.46,.24,.88,.65,1.22,1.2,.3,.48,.51,1.01,.72,1.52l.09,.22Zm-2.56-2.84c-.07,0-.14,.01-.2,.05-.19,.11-.23,.39-.2,.6,.05,.45,.33,.89,.75,1.21,.3,.23,1.09,.47,1.81,.63-.17-.43-.36-.87-.61-1.26-.32-.51-.7-.89-1.12-1.11-.1-.05-.26-.12-.42-.12Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.67,452.73l-.02-.24c-.04-.55-.08-1.12-.01-1.68,.07-.65,.26-1.19,.58-1.61,.22-.3,.5-.45,.74-.43,.34,.03,.56,.34,.66,.62,.17,.49,.11,1.08-.16,1.61-.27,.52-1.29,1.34-1.6,1.59l-.19,.15Zm1.25-3.71c-.22,0-.4,.21-.5,.33-.29,.39-.46,.89-.53,1.49-.05,.46-.03,.94,0,1.4,.57-.46,1.18-1.02,1.35-1.36,.24-.47,.3-.99,.15-1.42-.07-.2-.22-.43-.44-.45h-.03Z",
    style: {
      fill: "#0F7D3B"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M402.98,347.91s-18.47,18.06-28.07,27.03c-9.6,8.97-39.81,7.64-39.81,7.64l11.4,58.18-15.66,1.89s-14.77-43.17-20.5-66.26c-.83-3.35,.72-8.4,2.23-10.53,6.33-8.91,53.31-10.42,53.31-10.42l1.03-6.27,36.06-1.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.39,394.3s-8.27-14.57-10.04-20.4c-1.76-5.83-1.22-8.01,3.12-9.77,4.34-1.76,35.08-5.45,35.08-5.45l.49-2.54,6.34,6.92s-36.35,2.43-35.94,8.4c.41,5.97,.95,22.84,.95,22.84Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.98,347.91s3.8,22.44-3.95,28.18c-7.4,5.49-38.67,8.76-38.67,8.76l9.6,58.5-15.33,2.69s-14.91-44.6-20.65-67.68c-.83-3.35-.12-7.66,1.4-9.79,6.33-8.91,52.89-11.62,52.89-11.62l14.71-9.04Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.36,384.86s-2.45-3.56-4.3-5.02c0,0,5.3,1.76,6.31,4.9l-2.01,.12Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.36,348.43l3.36,5s21.13-7.14,23.62-9.54c2.49-2.39,5.59-23.92,5.59-23.92v-15.26l.25-11.05s-8.76,2.13-9.46,9.17c-.21,2.08-3.96,33.07-3.96,33.07l-19.41,12.54Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M336.27,360.94h30.79c0,1.19-1.32,2.13-2.93,2.13h-50.15c-1.6-.01-2.88-.96-2.88-2.13h25.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.52,362.95h28.13c.49,0,.88-.32,.87-.71,0-.07-.02-.15-.04-.22l-12.51-28.69c-.32-.82-1.26-1.38-2.33-1.38h-28.14c-.48,0-.86,.31-.86,.69,0,.08,.02,.16,.05,.23l12.51,28.69c.32,.82,1.26,1.37,2.33,1.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.49,331.95h28.14c1.07,0,2.01,.56,2.33,1.38l12.04,27.6h25.06c0,1.19-1.32,2.13-2.93,2.13h-50.15c-.51,0-.98-.11-1.39-.28-.65-.22-1.18-.66-1.4-1.22l-12.51-28.69c-.03-.08-.05-.15-.05-.24,0-.38,.39-.69,.86-.69Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.39,347.22c.61,1.38,1.84,2.32,2.76,2.13,.92-.19,1.16-1.45,.57-2.83-.59-1.38-1.84-2.3-2.75-2.11-.92,.19-1.19,1.4-.58,2.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.96,333.33l12.04,27.6h-1.3l-13.06-28.99c1.07,0,2.01,.56,2.33,1.38Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.49,331.95h28.14c1.07,0,2.01,.56,2.33,1.38l12.04,27.6h25.06c0,1.19-1.32,2.13-2.93,2.13h-50.15c-.51,0-.98-.11-1.39-.28-.65-.22-1.18-.66-1.4-1.22l-12.51-28.69c-.03-.08-.05-.15-.05-.24,0-.38,.39-.69,.86-.69Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M363.58,355.54s-4.89-5.88-3.32-7.02l.57-54.45,1.36-.41,11.06-2.53,11.43-2.46,6,1.25,10.56,11.65s1.49,28.41,1.57,29.7c.1,1.58,.86,22.17,.86,22.17-18.09,3.97-40.38,3.52-40.09,2.12Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M369.49,292.07l4.61,6.9,8.47-10.44s-2.26-1.75-4.16-3.38c-1.51-1.29-5.6-6.46-5.6-6.46l-1.12,.98-7.12,6.14s5.08,2.9,4.96,3.98c.2,.94,.42,1.9-.11,2.27",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.53,289.81c.2,1.05,.31,1.27-.04,2.27,5.33-1.12,2.78-12.36,2.78-12.36h-.58l-7.12,6.14s5.12,2.92,4.96,3.95Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350.82,268.72c-.73,3.04,.21,9.11,4.22,6.83,4.01-2.27-2.97-12.05-4.22-6.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.45,271.26c.99,7.61,1.7,11.88-1.37,16.43-4.61,6.85-14.34,5.25-17.59-1.93-2.92-6.46-4.05-17.82,2.76-22.16,6.71-4.28,15.21,.05,16.2,7.66Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,261.03c-1.83-3.94-7.63-5.2-10.12-2.52-.37,.4,3.12,.89,2.72,.83l1.41,6.06c.43-.18,1.4,.17,2.12,1.47,0,0,.43,8.17,4.34,10.88,7.41-5.32,5.45-16.05-.47-16.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.63,276.96c-.23,2.05-1.39,3.8-2.74,4.83-2.03,1.55-4.01-.04-4.25-2.45-.22-2.17,.57-5.59,3-6.19,2.39-.59,4.25,1.47,3.99,3.81Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.11,275.5c.15,.77-.14,1.47-.65,1.56-.5,.09-1.03-.46-1.18-1.23-.15-.77,.14-1.47,.64-1.56,.5-.09,1.03,.46,1.18,1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.59,277.11c.15,.77-.14,1.47-.64,1.56-.5,.09-1.03-.46-1.18-1.23-.15-.77,.14-1.47,.64-1.56,.5-.09,1.03,.46,1.18,1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.96,276.21s-1.7,4.29-2.18,6c1.26,.76,3.02-.04,3.02-.04l-.84-5.96Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.99,271.06c-.1,.07-.25,.09-.37,.03-1.49-.69-2.65,0-2.66,0-.17,.11-.4,.05-.51-.12-.11-.17-.05-.4,.12-.5,.06-.04,1.51-.9,3.36-.04,.18,.09,.26,.3,.18,.49-.03,.06-.07,.11-.12,.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,275.42c-.07,0-.14-.04-.2-.08-.16-.13-.18-.36-.05-.52,1.29-1.56,2.96-1.37,3.04-1.37,.2,.02,.35,.21,.32,.41-.02,.2-.2,.34-.4,.32-.07-.01-1.36-.14-2.39,1.11-.08,.1-.2,.14-.32,.13Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.72,261.54c-.06,0-.11-.02-.16-.06-.11-.09-.12-.25-.03-.35,.95-1.14,2.16-2.02,3.25-2.36,.13-.04,.27,.03,.31,.17,.04,.13-.03,.27-.17,.31-.98,.3-2.13,1.14-3.01,2.2-.05,.06-.12,.09-.19,.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.83,261.42s-.05,0-.08-.01c-.13-.04-.2-.18-.16-.31,.44-1.36,.36-2.89-.23-4.2-.06-.13,0-.27,.13-.33,.13-.06,.27,0,.33,.13,.64,1.42,.73,3.08,.25,4.56-.03,.11-.13,.17-.24,.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.51,278.37c-.13,0-.24-.1-.25-.23-.05-.71,.08-1.42,.38-2.06,.21-.43,.59-1.02,1.22-1.31,.63-.29,1.38-.18,1.82,.26,.1,.1,.1,.26,0,.35-.1,.1-.26,.1-.35,0-.29-.29-.82-.36-1.26-.16-.5,.23-.81,.71-.98,1.07-.27,.56-.38,1.18-.33,1.8,.01,.14-.09,.26-.23,.27h-.02Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.69,283.97h0c1.75-.45,3.18-1.71,3.83-3.4,.04-.1-.02-.21-.12-.24h-.01c-.09-.04-.2,.01-.23,.11h0c-.62,1.57-1.94,2.73-3.56,3.16-.09,.04-.14,.14-.1,.23h0c.04,.1,.14,.14,.23,.11h0l-.05,.04Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M367.52,292.44c.15-.22,2.18-1.67,2.18-1.67l4.06,3.2,5.83-8.08,5.09,2.77-10.77,13.54-6.39-9.77Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.94,356.39c-.1,0-.2-.07-.24-.17-2.37-6.91-2.06-14.69-1.76-22.21,.11-2.71,.22-5.5,.19-8.17-.08-8.75,.34-18.46,1.33-30.55,.01-.14,.13-.25,.27-.23,.14,.01,.24,.13,.23,.27-.99,12.07-1.41,21.77-1.33,30.5,.02,2.67-.09,5.48-.19,8.19-.3,7.48-.6,15.21,1.73,22.03,.04,.13-.02,.27-.16,.32-.03,0-.05,.01-.08,.01Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.24 327.57 385.12 328.06 386.87 306.27 388.14 324.89 402.5 325.49 390.24 327.57",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.52,292.44c.11,.17,2.47,4.85,3.47,6.83,.17,.33,.65,.3,.77-.04l1.81-4.89-2.23,3.8-3.82-5.69Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.94,294.05c.15,.15,4.15,4.44,4.15,4.44l5.87-9.83-5.02,11.2c-.23,.52-.95,.57-1.25,.09l-3.75-5.91Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.28,315.93s-.03,15.72-.07,15.88c-.03,.17-27.4,11.6-27.4,11.6,0,.41,4.07,5.16,4.07,5.16,0,0,29.85-3.92,33.22-9.01,2.88-4.34,3.33-23.84,3.33-23.84l-13.15,.2Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.68,289.91c10.9,.92,13.58,9.04,13.38,21.4-.19,11.9,.1,14.54,.1,14.54l-16.35-.36s-.27-21.24-.27-23.29,3.14-12.3,3.14-12.3Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.48,330.6l-14.98-3.77s4.11-21.32,4.81-24.89c.8-4.05,5.7-7.12,9.88-8.28l3.52,13.7-3.23,23.24Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.26,330.04c-.16-.04-2.42-21.75-2.42-21.75l-1.24,20.84,3.66,.92Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M348.45,358.52c.14-1.4,2.77-7.54,4.12-9.58,1.35-2.04,10.24-5.53,10.24-5.53l5.22,3.77s0,2.18-1.85,3.76c-1.06,.91-4.65,1.83-4.65,1.83,0,0,.3,1.11,.3,2.35,0,1.38-.27,3.07-1.41,3.02-1.13-.05-1.55-3.7-1.6-4.23,.05,.53,.37,4.27-1.15,4.4-1.46,.13-1.7-3.77-1.7-3.77,0,0-.08,1.81-.12,2.74-.05,.93-.98,1.73-1.84,.7-1-1.2-1.08-3.26-1.08-3.26,0,0-.79,1.21-1.97,3.84-.85,1.89-2.63,1.13-2.51-.05Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.87,354.72c-.13,0-.24-.1-.25-.24-.03-.7-.07-1.43,.03-2.15,.12-.83,.4-1.52,.84-2.05,.09-.11,.25-.12,.35-.03,.11,.09,.12,.25,.03,.35-.38,.45-.63,1.07-.73,1.8-.09,.67-.06,1.38-.03,2.06,0,.14-.1,.25-.24,.26h-.01Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,355.22c-.13,0-.24-.1-.25-.24-.03-.7-.07-1.43,.03-2.15,.12-.84,.4-1.53,.84-2.05,.09-.1,.25-.12,.35-.03,.11,.09,.12,.25,.03,.35-.38,.45-.62,1.06-.73,1.8-.09,.67-.06,1.38-.03,2.05,0,.14-.1,.25-.24,.26h-.01Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.95,354.96c-.13,0-.24-.1-.25-.24-.03-.7-.07-1.43,.03-2.15,.12-.83,.4-1.52,.84-2.05,.09-.11,.25-.12,.35-.03,.11,.09,.12,.25,.03,.35-.38,.45-.63,1.07-.73,1.8-.09,.67-.06,1.38-.03,2.06,0,.14-.1,.25-.24,.26h-.01Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M370.36,258.33c-.69-.87-1.79-1.32-2.89-1.5-1.48-.25-3.02-.14-4.45,.3-1.65,.51-3.16,1.47-4.86,1.73-.21,.03-.45,.04-.6-.1-.11-.1-.14-.25-.19-.39-.3-.92-1.23-1.61-2.2-1.61-.97,0-1.91,.67-2.21,1.6-.93-1.46-3.16-1.63-4.63-.72-1.48,.91-2.33,1.93-2.82,3.59-.17,.58-.24,1.85-.03,2.8,.43,1.9,1.47,3.06,3.13,4.07,2.24,1.36,4.89,2.3,7.47,1.83,3.44-.63,6.05-3.59,9.45-4.42,1.28-.31,2.81-.23,3.7,.74l2.77-5.22c0-.88-.85-1.71-1.65-2.71Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_1--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "201.14 449.2 208.21 448.88 210.83 430.49 200.06 430.86 201.14 449.2",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.07,445.66h-2.51c-.57,0-1.1,.29-1.43,.75-1.45,1.98-2.54,1.23-4.12-.63-1-.12-1.27,1.03-1.35,1.34l-1.88,6.84c-.16,.57,.17,1.17,.74,1.33,.1,.03,.21,.04,.31,.04h19.92c3.17,0,3.83-3.19,2.52-3.49-5.87-1.3-10.03-3.02-11.84-4.73-.34-.3,0-.52-.36-1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.99,447.94c.26-.19,.42-.49,.43-.82,.02-.17-.06-.35-.21-.44-.79-.56-3.93,.91-4.28,1.08-.04,.01-.07,.05-.08,.08-.03,.07,.01,.15,.08,.18,.77,.18,1.56,.28,2.36,.3,.6,.06,1.19-.08,1.71-.39Zm.02-1.03c.06,.04,.1,.11,.08,.19-.01,.24-.13,.45-.31,.6-.71,.53-2.44,.3-3.37,.13,1.31-.57,3.16-1.22,3.6-.92Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.03,448.06c.94-.39,2.92-1.95,2.82-2.77-.02-.17-.14-.38-.57-.44-1.72-.2-2.46,2.9-2.46,3.03-.02,.05,0,.11,.04,.15,.03,0,.07,0,.1,0l.07,.02Zm2.19-2.95c.32,.03,.32,.15,.32,.19,.09,.5-1.35,1.79-2.37,2.33,.21-.72,.85-2.53,1.94-2.53h.11Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.14,449.56s-.09-.01-.13-.04c-.12-.07-.15-.23-.08-.34,.51-.8,1.37-1.36,2.31-1.49,.13-.01,.26,.08,.28,.21s-.08,.26-.21,.28c-.8,.11-1.53,.58-1.96,1.26-.05,.08-.13,.12-.21,.12Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.71,450.74s-.09-.01-.13-.04c-.12-.07-.15-.23-.08-.34,.51-.8,1.37-1.36,2.31-1.49,.13-.01,.26,.08,.28,.21s-.08,.26-.21,.28c-.8,.11-1.53,.58-1.96,1.26-.05,.08-.13,.12-.21,.12Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.65,451.73s-.09-.01-.13-.04c-.12-.07-.15-.23-.08-.34,.51-.8,1.37-1.36,2.31-1.49,.13-.02,.26,.08,.28,.21,.02,.14-.08,.26-.21,.28-.8,.11-1.53,.58-1.96,1.26-.05,.08-.13,.12-.21,.12Z",
    style: {
      fill: "#0F7D3B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "209.4 440.52 209.06 442.88 200.76 442.74 200.63 440.52 209.4 440.52",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "230.6 447.38 238.27 446.41 239.96 429.07 229.43 428.78 230.6 447.38",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M238.66,444.96h-2.51c-.57,0-1.1,.29-1.43,.75-1.45,1.98-2.54,1.23-4.12-.63-1-.12-1.27,1.03-1.35,1.34l-1.88,6.84c-.16,.57,.17,1.17,.74,1.33,.1,.03,.21,.04,.31,.04h19.92c3.17,0,3.83-3.19,2.52-3.49-5.87-1.3-10.03-3.02-11.84-4.73-.34-.3,0-.52-.36-1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.11,446.9c.26-.19,.42-.5,.43-.82,.02-.17-.06-.35-.21-.44-.79-.56-3.93,.91-4.28,1.08-.04,.01-.07,.05-.08,.08-.03,.07,.01,.15,.08,.18,.77,.18,1.56,.28,2.36,.3,.6,.06,1.19-.08,1.71-.39Zm.02-1.03c.06,.04,.1,.11,.08,.19-.01,.24-.13,.45-.31,.6-.71,.53-2.44,.3-3.37,.13,1.31-.57,3.16-1.22,3.6-.92Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.16,447.02c.94-.39,2.92-1.95,2.82-2.77-.02-.17-.14-.38-.57-.43-1.72-.2-2.46,2.9-2.46,3.03-.02,.05,0,.11,.04,.15,.03,0,.07,0,.1,0l.07,.02Zm2.19-2.95c.32,.03,.32,.15,.32,.19,.09,.5-1.35,1.79-2.37,2.33,.21-.72,.85-2.53,1.94-2.53h.11Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.27,448.53s-.09-.01-.13-.04c-.12-.07-.15-.23-.08-.34,.51-.8,1.37-1.36,2.31-1.49,.13-.01,.26,.08,.28,.21s-.08,.26-.21,.28c-.8,.11-1.53,.58-1.96,1.26-.05,.08-.13,.12-.21,.12Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.83,449.7s-.09-.01-.13-.04c-.12-.07-.15-.23-.08-.34,.51-.8,1.37-1.36,2.31-1.49,.13-.01,.26,.08,.28,.21,.02,.14-.08,.26-.21,.28-.8,.11-1.53,.58-1.96,1.26-.05,.08-.13,.12-.21,.12Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.78,450.69s-.09-.01-.13-.04c-.12-.07-.15-.23-.08-.34,.51-.81,1.37-1.36,2.31-1.49,.13-.01,.26,.08,.28,.21s-.08,.26-.21,.28c-.8,.11-1.53,.58-1.96,1.26-.05,.08-.13,.12-.21,.12Z",
    style: {
      fill: "#0F7D3B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "238.94 439.48 238.71 441.85 230.25 441.8 230.1 439.48 238.94 439.48",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--character-2--inject-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.73,248.9c-2.02-10.51,4.53-8.57,2.3-21.95-2.46-14.74,8.05-16.87,8.05-16.87,0,0,1.24-7.34,8.1-6.96,6.86,.38,24.04,4.02,20.59,22.24-2.01,10.62,1.52,11.4,3.32,16.19,2.55,6.77-5.58,12.85-.27,17.48,0,0-13.61,3.99-33.47,2.66,0,0-7.39-6.38-8.62-12.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.72,252.85s9.34,23.37,10.82,23.51,20.43-7.24,20.43-7.24l2.95,3.33s-9.92,13.27-25.63,17.48c-2.82,.76-6.38-2.44-9.78-6.81-.67-.85-1.32-1.75-1.96-2.67-3.49-5.18-6.63-10.6-9.38-16.21l12.56-11.39Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.72,252.85s9.34,23.37,10.82,23.51,20.43-7.24,20.43-7.24l2.95,3.33s-9.92,13.27-25.63,17.48c-2.82,.76-6.38-2.44-9.78-6.81-.67-.85-1.32-1.75-1.96-2.67-3.49-5.18-6.63-10.6-9.38-16.21l12.56-11.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.72,255.94c.73,3.24,2.45,8.09,3.8,11.54,.44,1.12,.63,2.32,.43,3.51-.58,3.4-3.52,4.49-4.5,7.2-.55,1.59-.86,3.25-.94,4.93-.67-.85-1.32-1.75-1.96-2.67l-1.45-5.73,4.63-18.78Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.39,278.96c-.88-.25-1.4-1.17-1.15-2.06l6.33-26.64c.38-1.26,1.51-2.15,2.83-2.2l20.3-.42c.22-.03,.44-.01,.66,.05,.88,.25,1.4,1.17,1.15,2.06l-6.33,26.64c-.38,1.26-1.51,2.15-2.83,2.21l-20.3,.42c-.22,.03-.44,.01-.66-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.39,278.96c-.88-.25-1.4-1.17-1.15-2.06l6.33-26.64c.38-1.26,1.51-2.15,2.83-2.2l20.3-.42c.22-.03,.44-.01,.66,.05,.88,.25,1.4,1.17,1.15,2.06l-6.33,26.64c-.38,1.26-1.51,2.15-2.83,2.21l-20.3,.42c-.22,.03-.44,.01-.66-.05Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.48,278.91c-.88-.25-1.4-1.17-1.15-2.05l6.33-26.64c.38-1.26,1.51-2.14,2.82-2.21l20.31-.42c.22-.03,.44-.01,.66,.05,.88,.25,1.4,1.17,1.15,2.06l-6.34,26.64c-.38,1.26-1.51,2.14-2.82,2.21l-20.31,.42c-.22,.03-.44,0-.65-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.48,278.91c-.88-.25-1.4-1.17-1.15-2.05l6.33-26.64c.38-1.26,1.51-2.14,2.82-2.21l20.31-.42c.22-.03,.44-.01,.66,.05,.88,.25,1.4,1.17,1.15,2.06l-6.34,26.64c-.38,1.26-1.51,2.14-2.82,2.21l-20.31,.42c-.22,.03-.44,0-.65-.05Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.8,263.21c-.11-1.17-1.15-2.02-2.31-1.91-1.65,.09-3.06,1.23-3.5,2.82-.08,.26-.1,.54-.08,.81,.12,1.16,1.15,2,2.31,1.88,1.65-.09,3.07-1.22,3.51-2.81,.07-.26,.1-.53,.07-.79Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.66,264.48c-.4-.03-2.1,.81-2.9,.25-.8-.56-.05-1.02-.05-1.02,1.46-.36,3.07-2.19,3.96-1.66,.89,.52,2.36,1.18,2.15,2.01-.24,.77-.54,1.52-.88,2.26,.23,.37,.26,.83,.08,1.23-.18,.46-.59,.8-1.07,.89,.28,.28,.42,.67,.4,1.07-.07,.63-1.73,1.46-1.73,1.46,0,0,.32,.99-.06,1.37-.65,.53-1.51,.73-2.33,.53-.97-.23-1.64-.57-1.57-1.55,.07-.98,1.82-.98,1.82-.98,0,0-3.3-1-2.6-1.62,.7-.62,3.33-.55,3.33-.55,0,0-4.46-.88-3.75-1.8,.71-.92,5.15-.67,5.15-.67,0,0,.45-1.2,.05-1.23Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.32,302.14l19.71,.08s6.89,34.67,6.48,73.54c.8,22.82,.16,64.78,.16,64.78h-12.82s-8.17-34.08-4.9-61.08c-1.19-4.66-2.78-12.72-3.71-16.83-2.62-11.09-4.59-22.33-5.9-33.65-2.25-21.22,.97-26.84,.97-26.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.07,315.75s7.11,31.92,3.18,46.87c-2.62-11.09-4.59-22.33-5.9-33.65l2.72-13.23Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75,293.06c-1.72,7.7-8.46,17.11-9.83,26.96-2.33,16.83,7.79,37.76,10.43,57.5-4,29.2,2.13,64.61,1.32,63.84h12.87c.39-2.6,3.03-42.16,4.34-65.6,1.11-20.52,2.88-72.11,2.88-72.11l-22.02-10.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.27,288.4c-.02-1.38-2.69-11.29-2.76-12.75-.33-7.07-1.12-14.1-2.36-21.07-.05-.3-.09-.61-.11-.91-.34-4.79,3.28-8.95,8.07-9.28,1.38-.1,2.83-.15,4.33-.19,1.5-.04,2.93-.04,4.31-.04,3.78-.07,7.56,.11,11.31,.53l.83,.11c1.41,.18,2.84,.42,4.22,.65,5.99,1.01,10.22,6.43,9.76,12.49-.67,7.93,5.31,12.77-2.34,18.12-.99,6.8,.48,21.33,3.33,31.35,1.01,3.56-27.82,3.09-44-2.26l5.4-16.74",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.27,288.4c-.02-1.38-2.69-11.29-2.76-12.75-.33-7.07-1.12-14.1-2.36-21.07-.05-.3-.09-.61-.11-.91-.34-4.79,3.28-8.95,8.07-9.28,1.38-.1,2.83-.15,4.33-.19,1.5-.04,2.93-.04,4.31-.04,3.78-.07,7.56,.11,11.31,.53l.83,.11c1.41,.18,2.84,.42,4.22,.65,5.99,1.01,10.22,6.43,9.76,12.49-.67,7.93,5.31,12.77-2.34,18.12-.99,6.8,.48,21.33,3.33,31.35,1.01,3.56-27.82,3.09-44-2.26l5.4-16.74",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.33,244.16s3.01,2.32,6.89,5.66c.81,.7,1.7,1.3,2.64,1.8,2.54,1.35,4.86,2.12,5.48,.9,.14-.27,.25-.56,.33-.87,.53-2.05,.31-4.93-1.34-6.25-1.87-1.49-2.77-2.76-2.43-4.77,.18-1.14,.59-2.32,1.07-3.47l-2.16-1.3-7.69-7.76c.88,4.76,1.27,13.26-2.78,16.07Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.82,241.06c-2.12-1.26-4.44-3.43-4.16-5.92,.12-1.05,.35-2.04,.6-2.68l4.3,5.69c-.35,.92-.48,1.52-.74,2.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.61,219.34c.72,7.9,.86,11.26,4.94,15.4,6.14,6.23,15.58,4.14,17.2-3.7,1.46-7.05,.03-18.79-7.73-22.12-7.65-3.27-15.14,2.51-14.42,10.41Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.85,221.91c.04,.84,.49,1.52,1.01,1.53,.52,.01,.91-.66,.87-1.49-.04-.84-.49-1.52-1.01-1.53-.52-.01-.91,.66-.87,1.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.65,221.89c.04,.81,.49,1.48,1.01,1.49,.52,.01,.91-.64,.87-1.45-.04-.81-.49-1.48-1.01-1.49-.52-.01-.91,.64-.87,1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.2,219c.1,.01,.2-.02,.28-.09,1.22-1.13,2.59-.73,2.6-.73,.2,.06,.41-.06,.46-.26,.05-.21-.08-.42-.29-.49-.07-.02-1.79-.52-3.3,.88-.15,.14-.15,.39,0,.55,.07,.08,.16,.13,.26,.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.27,217.92c.08-.03,.15-.09,.18-.17,.07-.18-.02-.41-.2-.51-1.81-1.02-3.15-.24-3.2-.21-.16,.09-.2,.32-.09,.5,.11,.18,.33,.25,.49,.16,.05-.03,1.1-.61,2.54,.2,.09,.05,.19,.06,.28,.03Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.53,221.5s1.24,2.96,2.63,4.8c.24,.32,.09,.79-.29,.93-.98,.36-2.12,.03-2.12,.03l-.23-5.77Z",
    style: {
      fill: "#a24e3f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.43,220.45l1.81-.43s-.99,1.35-1.81,.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.33,220.46l1.81-.43s-.99,1.35-1.81,.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.36,222.07s4.08-6.14,3.87-11.11c0,0,7.8-2.03,14.03,6.28,.99,1.32,1.58,3.53,2.47,5.44,0,0,1.49-15.04-11.86-16.27-13.33-1.23-15.94,17.5-9.44,23.81,0,0-1.59-4.3,.93-8.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.22,225.78c.93,1.62,2.45,2.64,3.84,2.99,2.09,.52,3.17-2.84,2.46-4.94-.64-1.89-2.7-3.14-4.74-2.72-2.01,.41-2.63,2.82-1.57,4.67Z",
    style: {
      fill: "#b97964"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,225.61c-.13,0-.24-.1-.25-.23-.05-.69-.37-1.34-.89-1.8-.52-.45-1.21-.69-1.9-.65-.13,.02-.26-.1-.27-.23,0-.14,.1-.26,.23-.27,.82-.05,1.64,.23,2.26,.77,.62,.54,1,1.32,1.06,2.14,0,.14-.1,.26-.23,.27h-.02Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.23,229.91c-1.96,0-2.66-1.82-2.66-1.84-.05-.13,.02-.27,.15-.32,.13-.05,.27,.02,.32,.15,.03,.08,.73,1.88,2.83,1.44,.13-.03,.27,.06,.29,.19,.03,.13-.06,.27-.19,.29-.26,.05-.5,.08-.73,.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.48,293.96l-1.75,5.44s19.62-3.45,29.46-12.24c7-6.26,5.91-8.9,5.91-8.9l-7.93,.77-25.68,14.94Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.34,265.97l-1.07,17.74c-2.96,1.88-4.92-.73-5.37-3.43v-5.11l6.44-9.21Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.4,263.28s-7.43,18.4-6.09,19.25c1.34,.85,22.73-5,22.73-5l3.37,4.84c-.72,3.18-37.63,23.21-40.64,6.46-1.83-10.18,9.24-39.77,9.24-39.77,9.1-3.56,11.39,14.23,11.39,14.23Z",
    style: {
      fill: "#0F7D3B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.4,263.28s-7.43,18.4-6.09,19.25c1.34,.85,22.73-5,22.73-5l3.37,4.84c-.72,3.18-37.63,23.21-40.64,6.46-1.83-10.18,9.24-39.77,9.24-39.77,9.1-3.56,11.39,14.23,11.39,14.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.73,282.84c2.53,.2,2.62-3.61,3.93-3.76,.77-.07,1.51-.26,2.22-.57,0,0-.83,2.29,0,2.11,.83-.18,3.5-.32,4.16-2.5,.66-2.18-1.72-6.84-2.26-7.49-.54-.65-3.39-.45-3.39-.45,0,0,3.06-.79,4.74-1.02,1.68-.23,2-2.15-.35-1.73-.96,.17-8.57,.23-9.39,1.01-.82,.78-3.88,8.47-3.88,8.47-1.13,.65,1.74,7.1,4.21,5.92Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229.37,269.94c-.78-.05-1.56,0-2.33,.15-.12,.03-.18,.15-.15,.27,.03,.1,.12,.17,.23,.16,.73-.15,1.47-.2,2.21-.15,.27,0,.32-.41,.05-.42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.29,272.25c.24,.12,.49-.22,.25-.35-1.42-.76-2.92-.33-4.36,.15-.26,.08-.07,.47,.18,.39,1.27-.42,2.66-.83,3.93-.19Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M234.41,274.13c-1.23-.73-2.74-.8-4.03-.17-.1,.06-.13,.2-.07,.3,.05,.08,.15,.12,.24,.09,1.15-.56,2.51-.51,3.61,.13,.23,.14,.48-.21,.24-.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.36,277.32c.11-.22,.2-.46,.26-.7,.06-.27-.34-.42-.41-.15-.18,.82-.69,1.53-1.41,1.96-.24,.13-.06,.52,.17,.39h-.02c.45-.25,.83-.61,1.12-1.03,.03,0,.05,.01,.09,0,.45-.16,.95-.03,1.26,.33,.18,.21,.51-.07,.32-.27-.35-.4-.87-.59-1.38-.53Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.008140bf7a6447db07e8136f9ecaae85.svg";
export { ForwardRef as ReactComponent };